import React from 'react'
import { MeetTeamIcon, OnlineEducationIcon, ExecusearchIcon } from '@pga/pga-component-library'
import { Container, Row, Col } from 'reactstrap'
import {
  StyledContainer,
  StyledCtaContainer,
  StyledCtaTitle,
  StyledCtaInfo,
  StyledLink,
  StyledButton,
  IconWrapper
} from './styles'

export const ctaConfig = ({ authReady, isLoggedIn }) => [
  {
    title: 'Meet our team',
    btnTxt: 'View consultant directory',
    btnLink: authReady && isLoggedIn
      ? 'https://resources.pga.org/career-advancement/career-services/pga-career-consultants'
      : 'https://www.pga.org/career-services',
    btnTarget: '_self',
    ctaInfo: 'Our team of industry professionals are committed to serving your needs.',
    icon: MeetTeamIcon
  },
  {
    title: 'Online Education',
    btnTxt: 'Start Now',
    btnLink: 'https://account.pga.org/education/programs',
    btnTarget: '_blank',
    ctaInfo: 'Leverage PGA Continuing Education to advance your career.',
    icon: OnlineEducationIcon
  },
  {
    title: 'ExecuSearch',
    btnTxt: 'Learn More',
    btnLink: 'https://www.pgaexecusearch.com/',
    btnTarget: '_blank',
    ctaInfo: 'The golf industry\'s premier recruitment, search, and consulting service.',
    icon: ExecusearchIcon
  }
]

export default ({ authReady, isLoggedIn }) => {
  return (
    <StyledContainer>
      <Container>
        <Row>
          {ctaConfig({ authReady, isLoggedIn }).map(({ title, ctaInfo, btnLink, btnTarget, btnTxt, icon: Icon }, index) => {
            return (
              <Col md='4' sm='12' key={index}>
                <StyledLink href={btnLink} target={btnTarget}>
                  <StyledCtaContainer>
                    <IconWrapper>
                      <Icon />
                    </IconWrapper>
                    <StyledCtaTitle>{title}</StyledCtaTitle>
                    <StyledCtaInfo>{ctaInfo}</StyledCtaInfo>
                    <StyledLink href={btnLink} target={btnTarget}>
                      <StyledButton outline>
                        {btnTxt}
                      </StyledButton>
                    </StyledLink>
                  </StyledCtaContainer>
                </StyledLink>

              </Col>
            )
          })}
        </Row>
      </Container>
    </StyledContainer>
  )
}
